import {useKeycloak} from '@react-keycloak/web';
import React from 'react';
import NotFoundModule from './NotFoundModule';
import {type EUserRoles} from '../../enums/EUserRoles';
import {userHasRole} from '../../utils/utils';

interface ProtectedRouteProps {
  children: JSX.Element;
  requiredRoles?: EUserRoles[][];
}

export default function AuthRequiredRoute({children, requiredRoles = []}: ProtectedRouteProps) {

  const {keycloak} = useKeycloak();
  if (!keycloak.authenticated) {
    const handleLogin = async () => {
      await keycloak.login();
    };
    return (
      <NotFoundModule
        loginButtonVisible
        onLoginClick={handleLogin}
      />
    );
  }
  if (!userHasRole(keycloak.tokenParsed, requiredRoles)) {
    return <NotFoundModule/>;
  }
  return children;
}